// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mr-0";
export var leftAlign = "_mr-4";
export var listItem = "_mr-2";
export var listItemWrapper = "_mr-1";
export var operationText = "_mr-3";